module.exports = __webpack_public_path__ + "static/media/Hauwei.5e5fef57.svg";